(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-thumbnails"] && !Shopify.designMode) return;
  try {
    
function openVideoPopup(src) {
  const popup = document.getElementById('videoPopup');
  const video = document.getElementById('popupVideo');
  video.src = src;
  popup.classList.add('active');
}
function closeVideoPopup() {
  const popup = document.getElementById('videoPopup');
  const video = document.getElementById('popupVideo');
  video.pause();
  video.src = '';
  popup.classList.remove('active');
}

  } catch(e) { console.error(e); }
})();
})();
